import { defineStore, storeToRefs } from 'pinia';
import { ref, watch } from 'vue';
import WidgetApiService from '@/common/services/widget-api.service';
import { PaymentTypes } from '@/types/payment';
import { CountryTypes } from '@/types/country';
import { useAuthStore } from './auth';
import useTransactionsStore from './transactions';
export const usePaymentStore = defineStore('payment', () => {
    const currentStep = ref(PaymentTypes.PaymentSteps.PAYMENT_1);
    const authStore = useAuthStore();
    const { token, partnerSessionId, deviceId, user } = storeToRefs(authStore);
    const transactionsStore = useTransactionsStore();
    const selectedPaymentNetwork = ref(null);
    const sellPaymentAccountNumber = ref('');
    const sellPaymentAccountName = ref('');
    const sellPaymentBranchCode = ref('');
    const paymentNetworks = ref([]);
    const fetchingAccountName = ref(false);
    const accountNameKey = ref(Math.random());
    let controller = new AbortController();
    const userMomoAccountNumber = ref('');
    function resetStore() {
        selectedPaymentNetwork.value = null;
        sellPaymentAccountNumber.value = '';
        sellPaymentAccountName.value = '';
        sellPaymentBranchCode.value = '';
        fetchingAccountName.value = false;
    }
    async function getNetworks(params) {
        try {
            paymentNetworks.value = await WidgetApiService.GetNetworks(token.value, partnerSessionId.value, deviceId.value, params.channelId, params.country, params.accountType);
        }
        catch (e) {
            throw new Error(`${e.message}`);
        }
    }
    async function validateAccountNumber() {
        if (user.value?.country !== CountryTypes.Countries.NIGERIA &&
            transactionsStore.countryConfig.country !==
                CountryTypes.CountryCodes.NIGERIA) {
            return;
        }
        if (!selectedPaymentNetwork.value)
            return;
        if (!sellPaymentAccountNumber.value)
            return;
        if (sellPaymentAccountNumber.value.length < 10)
            return;
        try {
            if (fetchingAccountName.value) {
                controller.abort();
                fetchingAccountName.value = false;
            }
            fetchingAccountName.value = true;
            controller = new AbortController();
            sellPaymentAccountName.value = await WidgetApiService.ResolveAccountName(token.value, partnerSessionId.value, deviceId.value, selectedPaymentNetwork.value.id, sellPaymentAccountNumber.value, controller.signal);
            fetchingAccountName.value = false;
            controller.abort();
            accountNameKey.value = Math.random();
        }
        catch (e) {
            fetchingAccountName.value = false;
            throw new Error(`${e.message}`);
        }
    }
    watch([selectedPaymentNetwork, sellPaymentAccountNumber], async () => {
        await validateAccountNumber();
    });
    return {
        currentStep,
        getNetworks,
        selectedPaymentNetwork,
        sellPaymentAccountName,
        sellPaymentAccountNumber,
        sellPaymentBranchCode,
        paymentNetworks,
        fetchingAccountName,
        accountNameKey,
        resetStore,
        userMomoAccountNumber,
    };
});
export default usePaymentStore;
